import { useEffect, useState } from "react";
import "aos/dist/aos.css";
import { Form, Input, Button, Alert, message } from "antd";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { LoginAction } from "../../../redux/actions/AuthActions";
import HttpService from "../../../services/HttpService";
import { setCookie } from "cookies-next";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [forgottenEmail, setForgottenEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [forgottenPassword, setForgottenPassword] = useState(false);

  const router = useRouter();
  const dispatch = useDispatch();

  const handleUserLogin = () => {
    const httpService = new HttpService();
    httpService.getData("checkIfUserExists?email=" + email).then((res) => {
      if (res.success == true) {
        const fields = {
          email: email,
          password: password,
        };
        setCookie("loginUrl", router.asPath);
        dispatch(LoginAction(fields, router, res.exists ? "users" : "client_users"));
      } else {
        message.error("Oups ! Nous avons rencontré un problème.");
      }
    });
  };

  const selector = useSelector((state) => state.userAuth);

  useEffect(() => {
    if (selector?.authResponse?.message == "Invalid username or password") {
      setError(
        "L'e-mail et le mot de passe que vous avez entré ne correspondent pas."
      );
    }
    if (selector?.authResponse?.message == "Sorry, this user does not exist") {
      setError(
        // "Nous n'arrivons pas à vous connecter, veuillez contacter votre conseiller au 06 01 73 09 58."
        "Vous n'avez pas encore de compte, veuillez en créer un."
      );
    }
  }, [selector]);

  const handleForgottenPassword = () => {
    const fields = {
      email: forgottenEmail,
    };
    const http = new HttpService();
    http
      .postData(fields, "password/email")
      .then((response) => {
        setSuccess(response.message);
      })
      .catch((response) => {
        setError(
          "Nous avons rencontré un problème lors de la réinitialisation de votre mot de passe."
        );
      });
  };

  return !forgottenPassword ? (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 13 }}
      onFinish={handleUserLogin}
    >
      <Form.Item
        label="E-mail"
        name="email"
        rules={[
          {
            type: "email",
            message: "Veuillez renseigner une adresse e-mail correcte.",
          },
          {
            required: true,
            message: "Veuillez renseigner votre email.",
          },
        ]}
      >
        <Input
          id={"email"}
          name="email"
          type="text"
          value={email}
          placeholder="Email"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </Form.Item>
      <Form.Item
        label="Mot de passe"
        name="password"
        rules={[
          {
            required: true,
            message: "Veuillez entrer votre mot de passe.",
          },
        ]}
      >
        <Input
          id={"password"}
          name="password"
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
      </Form.Item>
      {error && <Alert description={error} type="error" />}
      <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
        <Button type="success" htmlType="submit">
          Me connecter
        </Button>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
        {/* <Link href="/signup">
          <Button type="primary">Pas encore de compte</Button>
        </Link> */}
        <Button type="primary">
          <a href="/signup">Pas encore de compte</a>
        </Button>
      </Form.Item>
      <Form.Item
        wrapperCol={{ offset: 4, span: 16 }}
        className="noAccountWrapper"
      >
        <Button type="secondary" onClick={() => setForgottenPassword(true)}>
          Vous avez oublié votre mot de passe ?
        </Button>
      </Form.Item>
    </Form>
  ) : (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 13 }}
      onFinish={handleForgottenPassword}
    >
      <Form.Item
        label="E-mail"
        name="forgotten_email"
        rules={[
          {
            type: "email",
            message: "Veuillez renseigner une adresse e-mail correcte.",
          },
          {
            required: true,
            message: "Veuillez renseigner votre email.",
          },
        ]}
      >
        <Input
          id={"forgotten_email"}
          name="forgotten_email"
          type="text"
          value={forgottenEmail}
          placeholder="exemple@exemple.com"
          onChange={(e) => {
            setForgottenEmail(e.target.value);
          }}
        />
      </Form.Item>
      {error && <Alert description={error} type="error" />}
      {success && <Alert description={success} type="success" />}
      {!success && (
        <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
          <Button type="success" htmlType="submit">
            Réinitialiser le mot de passe
          </Button>
        </Form.Item>
      )}
    </Form>
  );
}
